import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiShield } = FiIcons;

export default function Footer() {
  return (
    <footer className="bg-slate-900 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Top Row */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-10 mb-12">

          {/* Brand */}
          <div className="max-w-xs">
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-blue-600 p-2 rounded-lg">
                <SafeIcon icon={FiZap} className="h-5 w-5 text-white" />
              </div>
              <span className="font-bold text-xl text-white">GetSwitchFree</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Finance your carrier buyout and switch to an affordable plan — starting at $8/mo.
            </p>
          </div>

          {/* Nav Links */}
          <div className="flex flex-col gap-3">
            <p className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-1">Navigate</p>
            <Link to="/how-it-works" className="text-slate-400 hover:text-white text-sm transition-colors">How it Works</Link>
            <Link to="/dashboard" className="text-slate-400 hover:text-white text-sm transition-colors">Get a Quote</Link>
            <Link to="/auth" className="text-slate-400 hover:text-white text-sm transition-colors">Sign In</Link>
          </div>

          {/* Legal Links */}
          <div className="flex flex-col gap-3">
            <p className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-1">Legal</p>
            <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors">Terms of Service</Link>
            <Link to="/disclosure" className="text-slate-400 hover:text-white text-sm transition-colors">Affiliate Disclosure</Link>
          </div>
        </div>

        {/* Disclaimer Banner */}
        <div className="bg-slate-800 border border-slate-700 rounded-2xl px-6 py-5 mb-10 flex items-start gap-4">
          <SafeIcon icon={FiShield} className="w-5 h-5 text-blue-400 mt-0.5 shrink-0" />
          <p className="text-slate-400 text-xs leading-relaxed">
            <span className="text-slate-300 font-semibold">GetSwitchFree.com</span> is a comparison
            platform, not a lender or cellular provider. We may receive commissions from partners
            featured on this site. Checking rates on our platform will not impact your credit score.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} GetSwitchFree Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-slate-500 text-xs">
            <SafeIcon icon={FiShield} className="w-3.5 h-3.5 text-green-500" />
            Bank-level 256-bit SSL encryption
          </div>
        </div>

      </div>
    </footer>
  );
}